<template>
    <component :is="element" :class="[{ 'show': open }, classList]">
        <a @click.prevent.stop="toggle" href="javascript:void(0)" class="nav-link text-black lg:text-white">
            <slot name="link" />
        </a>

        <!-- <portal v-if="open" to="dropdowns"> -->
            <ul class="navbar-menu-sub">
                <div v-on-clickaway="hide">
                    <slot name="items" />
                </div>
            </ul>
        <!-- </portal> -->
    </component>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

/**
 * @todo on hover show dropdown
 */
export default {
    mixins: [clickaway],

    props: [
        'type',
        'active',
        'class-list'
    ],

    data: () => ({
        element: null,
        open: false
    }),

    created() {
        this.element = this.type || 'div';

        if (this.mobile && this.active) {
            this.show();
        }
    },

    mounted() {},

    computed: {},

    methods: {
        toggle($event) {
            if (this.open) {
                this.hide();
            } else {
                this.show();
            }
        },

        show($event) {
            document
                .querySelectorAll('.navbar-menu .with-sub.show')
                .forEach(e => e.classList.remove('show'));
            document
                .querySelectorAll('.dropdown-menu.show')
                .forEach(e => e.classList.remove('show'));

            this.open = true;

            // this.$emit('menu-opened');
        },

        hide($event) {
            this.open = false;

            // this.$emit('menu-closed');
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
